<!-- Todo Main Sidebar (Filter) -->
<core-sidebar 
class="sidebar-left" 
name="todo-sidebar-main-one" 
overlayClass="body-content-overlay"
collapsibleSidebar="bs-gt-lg" *ngIf="(activeView$ | async) === 'chart_view' || (activeView$ | async) === 'graph_view'">
<!-- Main Sidebar -->
  <div class="main-sidebar sidebar documentMainSideBar">
    <div class="sidebar-content todo-sidebar">
      <div class="todo-app-menu pt-75 pb-75 documentMainSideBarScroll">
        <div class="sidebar-menu-list">
          
          <div class="list-group list-group-filters">
            <a class="list-group-item list-group-item-action" [ngClass]="{'active':  (activeView$ | async) === 'graph_view'}" (click)="toggleViews('graph_view')">
              <i size="18" class="me-50 feather icon-copy align-middle"></i>
              <span class="align-middle">General</span>
              <!-- <span class="align-middle">{{ t('General tab name (documents - data view) - General') }}</span> -->
            </a>
            <a class="list-group-item list-group-item-action" [ngClass]="{'active':  (activeView$ | async) === 'chart_view'}" (click)="toggleViews('chart_view')">
              <i size="18" class="me-50 feather icon-clock align-middle"></i>
              <span class="align-middle">Margin</span>
              <!-- <span class="align-middle">{{ t('Margin tab name (documents - data view) - Margin') }}</span> -->
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>
<!--/ Main Sidebar -->
</core-sidebar>
<!--/ Todo Main Sidebar -->
<ng-scrollbar autoHeightDisabled="false" visibility="hover" class="documentChartViewinnerContainer">
    <section class="p-2 px-1 pb-0 documentChartViewinnerWidthContainer">
        <div class="row">
            <!-- Donut Chart Starts -->
            <div class="col-lg-12 col-12 pe-0">
                <div class="card">
                    <div class="card-body pb-0">
                        <div class="row">
                            <div class="row float-start">
                                <div class="col-lg-12 col-12 pe-3 mb-2">
                                    <div class="btn-group" role="group" aria-label="Basic example">
                                      <button type="button" class="btn btn-outline-primary" rippleEffect>Last 7 days</button
                                      ><button type="button" class="btn btn-outline-primary" rippleEffect>Last 30 days</button
                                      ><button type="button" class="btn btn-outline-primary" rippleEffect>Custom</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="card mb-2">
                                    <div class="card-header px-0">
                                        <h4 class="card-title">Gross margin of signed documents</h4>
                                        <p class="font-small-3">Shows gross margin, total value and total cost of signed documents</p>
                                    </div>
                                    <div class="card-body pb-0">
                                        <div class="row">
                                            <div class="col-12 col-lg-12">
                                                <div class="chartContainer">
                                                    <apx-chart
                                                    [series]="marginSignedDocChart.seriesStatus"
                                                    [chart]="marginSignedDocChart.chart"
                                                    [labels]="marginSignedDocChart.labels"
                                                    [title]="marginSignedDocChart.title"
                                                    [theme]="marginSignedDocChart.theme"
                                                    [dataLabels]="marginSignedDocChart.dataLabels"
                                                    [responsive]="marginSignedDocChart.responsive"
                                                    [tooltip]="marginSignedDocChart.tooltip"
                                                    [legend]="marginSignedDocChart.legend">
                                                    </apx-chart>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div class="col-12 col-lg-6">
                                <div class="card mb-2">
                                    <div class="card-header px-0">
                                        <h4 class="card-title">Gross margin of active documents</h4>
                                        <p class="font-small-3">Shows you margin, total and cost of active documents</p>
                                    </div>
                                    <div class="card-body pb-0">
                                        <div class="row">
                                            <div class="col-12 col-lg-12">
                                                <div class="chartContainer">
                                                    <apx-chart
                                                    [series]="marginActiveDocChart.seriesStatus"
                                                    [chart]="marginActiveDocChart.chart"
                                                    [labels]="marginActiveDocChart.labels"
                                                    [title]="marginActiveDocChart.title"
                                                    [theme]="marginActiveDocChart.theme"
                                                    [dataLabels]="marginActiveDocChart.dataLabels"
                                                    [responsive]="marginActiveDocChart.responsive"
                                                    [tooltip]="marginActiveDocChart.tooltip"
                                                    [legend]="marginActiveDocChart.legend">
                                                    </apx-chart>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
            <!--/ Donut Chart Starts -->
        </div>
    
        <div class="row">
            <!-- Horizontal Bar Chart Start -->
            <div class="col-xl-12 col-12 pe-0">
                <div class="card">
                    <div class="card-header">
                        <div class="header-left">
                            <h4 class="card-title">Gross margin of signed documents per user based on sent Date</h4>
                            <p>Shows you gross margin per user of signed documents devided per user based on sent date</p>
                        </div>   
                    </div>
                    <div class="card-body pb-50">
                        <div class="">
                            <apx-chart
                                [series]="marginSignedDocuments.marginSignedDocumentsseries"
                                [chart]="marginSignedDocuments.chart"
                                [stroke]="marginSignedDocuments.stroke"
                                [dataLabels]="marginSignedDocuments.dataLabels"
                                [xaxis]="marginSignedDocuments.xaxis"
                                [colors]="marginSignedDocuments.colors"
                                [fill]="marginSignedDocuments.fill"
                                [yaxis]="marginSignedDocuments.yaxis"
                                [legend]="marginSignedDocuments.legend"
                                [tooltip]="marginSignedDocuments.tooltip"
                                [responsive]="marginSignedDocuments.responsive"
                                [plotOptions]="marginSignedDocuments.plotOptions"
                            ></apx-chart>
                        </div>
                    </div>
                </div>
            </div>
            <!--/ Horizontal Bar Chart End -->
        
            <!-- Horizontal Bar Chart Start -->
            <div class="col-xl-12 col-12 pe-0">
                <div class="card">
                    <div class="card-header">
                        <div class="header-left">
                            <h4 class="card-title">Gross margin of signed documents per user based on signed Date</h4>
                            <p>Shows you gross margin per user of signed documents devided per user based on signed date</p>
                        </div>
                    </div>
                    <div class="card-body pb-1">
                        
                        <div class="">
                            <apx-chart
                                [series]="basedOnSignedDateChart.basedOnSignedDateChartseries"
                                [chart]="basedOnSignedDateChart.chart"
                                [stroke]="basedOnSignedDateChart.stroke"
                                [dataLabels]="basedOnSignedDateChart.dataLabels"
                                [xaxis]="basedOnSignedDateChart.xaxis"
                                [colors]="basedOnSignedDateChart.colors"
                                [fill]="basedOnSignedDateChart.fill"
                                [yaxis]="basedOnSignedDateChart.yaxis"
                                [legend]="basedOnSignedDateChart.legend"
                                [tooltip]="basedOnSignedDateChart.tooltip"
                                [responsive]="basedOnSignedDateChart.responsive"
                                [plotOptions]="basedOnSignedDateChart.plotOptions"
                            ></apx-chart>
                        </div>
                    </div>
                </div>
            </div>
            <!--/ Horizontal Bar Chart End -->
        
            <!-- Horizontal Bar Chart Start -->
            <div class="col-xl-12 col-12 pe-0">
                <div class="card">
                    <div class="card-header">
                        <div class="header-left">
                            <h4 class="card-title">Gross margin per user based on sent Date (for active documents)</h4>
                            <p>Shows you gross margin per user (for active documents)</p>
                        </div>
                    </div>
                    <div class="card-body pb-1">
                        <div class="">
                            <apx-chart
                                [series]="sentDateForActive.sentDateForActiveseries"
                                [chart]="sentDateForActive.chart"
                                [stroke]="sentDateForActive.stroke"
                                [dataLabels]="sentDateForActive.dataLabels"
                                [xaxis]="sentDateForActive.xaxis"
                                [colors]="sentDateForActive.colors"
                                [fill]="sentDateForActive.fill"
                                [yaxis]="sentDateForActive.yaxis"
                                [legend]="sentDateForActive.legend"
                                [tooltip]="sentDateForActive.tooltip"
                                [responsive]="sentDateForActive.responsive"
                                [plotOptions]="sentDateForActive.plotOptions"
                            ></apx-chart>
                        </div>
                    </div>
                </div>
            </div>
            <!--/ Horizontal Bar Chart End -->
        </div>
    
        <div class="row">
            <!-- Scatter Chart Starts  -->
            <div class="col-lg-12 col-12 pe-0">
                <div class="card mb-0">
                    <div class="card-header">
                        <div>
                            <h4 class="card-title mb-25">Gross margin over time (for active documents)</h4>
                            <p>Shows gross margin of active documents over time</p>
                        </div>
                    </div>
                    <div class="card-body pb-0">
                        <div class="">
                            <apx-chart
                            [series]="marginOverTimeChart.seriesOverTime"
                            [chart]="marginOverTimeChart.chart"
                            [xaxis]="marginOverTimeChart.xaxis"
                            [stroke]="marginOverTimeChart.stroke"
                            [labels]="marginOverTimeChart.labels"
                            [title]="marginOverTimeChart.title"
                            [legend]="marginOverTimeChart.legend"
                            [dataLabels]="marginOverTimeChart.dataLabels"
                            [title]="marginOverTimeChart.title"
                            [yaxis]="marginOverTimeChart.yaxis">
                            </apx-chart>
                        </div>
                    </div>
                </div>
            </div>
            <!--/ Scatter Chart Ends  -->
        </div>
    </section>
</ng-scrollbar>